import { DateTime } from "luxon";
import { sleep } from "@shared/utils/tools.ts";
import {
  type DnsTxtVerificationDto,
  type ManualVerificationDto,
  type VerifyDomainRequest,
  type VerifyDomainResponse,
} from "@shared/types/localTypes/domains.ts";
import { type TourUrlHandlerConfig } from "@shared/types/localTypes/tour.ts";

const extractDomain = (originalUrl?: string): string => {
  if (!originalUrl) {
    return "tour-domain.com";
  }
  const match = originalUrl.match(/\/domains\/([^/?]+)\/verify/);
  return match ? decodeURIComponent(match[1]) : "tour-domain.com";
};

export default async (data?: object, config?: TourUrlHandlerConfig) => {
  const request = data as VerifyDomainRequest;
  await sleep(350);
  const domain = extractDomain(config?.originalUrl);
  const verifiedAt = DateTime.now().toISO();
  if (request.verification_method === "manual") {
    const verification: ManualVerificationDto = {
      verification_uuid: request.verification_id,
      method: "manual",
      status: "verified",
      last_verified_at: verifiedAt,
      details: {},
    };
    return { domain, verification } satisfies VerifyDomainResponse;
  }
  const verification: DnsTxtVerificationDto = {
    verification_uuid: request.verification_id,
    method: "dns_txt_record",
    status: "verified",
    last_verified_at: verifiedAt,
    details: {
      txt_record_value: `jfrog-verify=tour-token-${request.verification_id.slice(0, 8)}`,
      last_checked: verifiedAt,
    },
  };
  return { domain, verification } satisfies VerifyDomainResponse;
};
